import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import CompanionListItemNew from '../../../../CompanionListItemNew';
import { ResourceName } from '../../../../../../../components/reservation/ResourceName';
import { FirstRowData, SpaceTableOwnProps, TableRowData } from './types';

const isFirstRow = (data: TableRowData): data is FirstRowData =>
    typeof (data as FirstRowData).assignedResourceId !== 'undefined';

export const getTableMapping = ({ editProfile, billingScreen, editInternals }: Omit<SpaceTableOwnProps, 'scope'>) => [
    {
        title: <LocalizedText textKey={TextKey.Space} />,
        valueKey: 'space',

        render: (data: TableRowData) => {
            if (!isFirstRow(data)) {
                return null;
            }

            return <ResourceName resourceId={data.assignedResourceId} />;
        },
    },
    {
        title: <LocalizedText textKey={TextKey.Customer} />,
        valueKey: 'companionId',
        render: ({ customerId }: TableRowData) =>
            customerId ? (
                <CompanionListItemNew
                    customerId={customerId}
                    editProfile={editProfile}
                    billingScreen={billingScreen}
                    editInternals={editInternals}
                />
            ) : null,
    },
];
